module.exports = __webpack_public_path__ + "static/img/Save.155fa496.png";